// extracted by mini-css-extract-plugin
export default {"root":"_2H7FQ","textSeparator":"_2jK2A","textSeparatorLine":"_1QqJO","textSeparatorContent":"ycr_T"};